<template>
  <div class="row">
    <div class="col-md-12 mt50">
      <h4>{{ $t('Por albarán') }}</h4>

      <div v-if="loading">
        <div class="loading"><img src="@/assets/img/loading.gif" alt=""></div>
      </div>

      <template v-else>
        <!-- <div class="center">
          <div class="input-group widthPer30">
            <div class="input-group-addon"><i class="fa fa-filter"></i></div>
            <input type="text" class="form-control" :placeholder="$t('Filtro')" maxlength="150" v-model="filterData">
          </div>
        </div> -->

        <div v-if="error" class="frm-error">{{ error_message }}</div>
        
        <div v-for=" (consorcio, i) in albaranes " :class=" { 'proyecto albaranes': true, 'mt50': i > 0 } " :key="consorcio.consorcio_id">
          <h4 class="title mb0">{{ consorcio.nombre_consorcio }}</h4>
          
          <template v-for=" (referencia, index) in consorcio.referencias">
            <div class="row" :key="index">
              <div class="col-md-3">
                <h5 :class=" { 'mb0': true, 'mt40': true } ">{{ referencia.referencia }}</h5>
              </div>
              
              <div class="col-md-9 pt25">
                <a 
                  v-for=" (albaran) in referencia.albaranes " :key="albaran.id_albaran" 
                  :href="getApiUrl + getLocale + '/' + albaran.enlace + ( (getUserRole == 'badmin') ? ('&bibl=' + getActiveBiblioteca) : '')" 
                  class="c-albaran"
                  target="_blank"
                >
                  <span class="c-albaran-data-block">
                    <i class="fa fa-file-pdf-o"></i><span><b>{{ albaran.id_albaran }}</b></span><span class="text-center">{{ albaran.fecha }}</span><span class="text-right">{{ toCurrency(albaran.importe) }}</span>
                  </span>
                </a>
              </div>
            </div>
          </template>

        </div>

			</template>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Por albarán": "Por albarán",
    "Albarán": "Albarán",
    "Filtro": "Filtro"
  },
  "en": {
  },
  "ca": {
    "Por albarán": "Per albarà",
    "Albarán": "Albarà",
    "Filtro": "Filtre"
  }
}
</i18n>

<script>
  import axios from 'axios'; 
  import { mapGetters } from 'vuex';


  export default {
    data: () => {
      return{
        error: false,
        error_message: '',
        loading: false,
        filterData: '',
        albaranes:[]
      }
    },
    created(){
      this.loadAlbaranes();
    },
    computed: {
      ...mapGetters(['getLocale', 'getApiUrl', 'getUserRole', 'getActiveBiblioteca']), 
      /* albaranesFiltered: function(){
        return this.albaranes.filter( (item) => {
          return item.id_albaran.toLowerCase().includes(this.filterData.toLowerCase());
        })
      },
      albaranesFilteredLength: function(){
        return Object.keys(this.albaranesFiltered).length;
      },
      albaranesFiltered4th: function(){
        return Math.ceil(this.albaranesFilteredLength / 4);
      } */
    },
    methods: {
      loadAlbaranes(){
        this.showLoading();

        // INICIO CONSORCIOS
        // Para cpanel se necesita la referencia de la biblioteca
        // Si el consorcio inicia sesión y consulta mis pedidos no se necesita la referencia
        var suffix;
        if(this.getUserRole == 'badmin'){
          if (this.$route.path.search('cpanel') != -1) {
            suffix = '?bibl=' + this.getActiveBiblioteca;
          }else{
            suffix = ''
          }
        }else{
          suffix = ''
        }
        // FIN CONSORCIOS

        axios.get(this.getApiUrl + this.getLocale + '/misconsultas/albaran' + suffix)
          .then( (respuesta) =>{
            /*setTimeout(() => {*/
              this.albaranes = respuesta.data.data;
              this.hideLoading(); 
           /* },3000);*/
            
          })
          .catch( (error) =>{ 
            this.error_message = error.response.data.status + ' ' + error.response.data.msg;
            this.error = true;
            this.hideLoading();
          }); 
      },
      showLoading(){ this.loading = true; },
      hideLoading(){ this.loading = false; },
    },
    watch:{
    }
  }
</script>
